import React, { Component } from 'react';
import NavDesktop from "./NavDesktop/NavDesktop";
import NavMobile from "./NavMobile/NavMobile";

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mainItems: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/nav')
            .then(result => result.json())
            .then(result => {
                this.setState({
                    mainItems: result.mainItems
                }, () => {
                    this.setActiveStates();
                });
            });
    }

    resetNavigation() {
        this.NavDesktop.resetNavigation();
        this.forceUpdate();
        this.setActiveStates();
    }

    setActiveStates() {
        this.setState({
            mainItems: this.iterateItems(this.state.mainItems)
        });
    }

    iterateItems(items) {
        const mainItems = {};
        Object.keys(items).map(key => {
            let item = items[key];
            mainItems[key] = item;
            mainItems[key].active = this.checkActive(item);

            if (item.children) {
                const children = [];
                item.children.map(item => {
                    item.active = this.checkActive(item);
                    children.push(item);
                });
                mainItems[key].children = children;
            }
        });

        return mainItems;
    }

    checkActive(item) {
        let active = '';

        if (item.url !== '/' && window.location.pathname.includes(item.url)) {
            active = 'is-active';
        }

        // Gotcha: Small business was set active for /voip/small-business
        if (window.location.pathname === '/voip/small-business' && item.url === '/small-business') {
            active = '';
        }

        ['/internet', '/voip', '/small-business', '/network-solutions'].forEach(url => {
			if (this.isNotOverview(url, item.title)) {
				active = '';
			}
		});

        return active;
    }

    isNotOverview(url, title) {
		return (window.location.pathname.includes(url) && window.location.pathname !== url && title === 'Overview');
	}

    render() {
        return (
            <div className="nav-container" id="navigation">
                <div className="navigation-placeholder" />
                <NavDesktop
                    mainItems={this.state.mainItems}
                    ref={el => this.NavDesktop = el}
                />
                <NavMobile mainItems={this.state.mainItems} />
            </div>
        );
    }
}

export default Navigation;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/Navigation.js